import { AuthenticationContext, adalFetch } from "react-adal";

const tenantEnv = process.env.REACT_APP_WMD_TENANT;
const clientIdEnv = process.env.REACT_APP_WMD_CLIENT_ID;
const redirectUriEnv = window.location.protocol + "//" + window.location.hostname + ((window.location.port == "" || window.location.port == 443) ? "" : (":" + window.location.port))  + "/wmd/auth";

let config = {
  tenant: tenantEnv,
  clientId: clientIdEnv,
  redirectUri: redirectUriEnv,
  cacheLocation: "sessionStorage"
};

export const authContextWMD = new AuthenticationContext(config);

export const getToken = () => authContextWMD.getCachedToken(config.clientId);
export const getTokenAsync = (callback) =>
authContextWMD.acquireToken(config.clientId, callback);
export const getUser = () => authContextWMD.getCachedUser(config.clientId);
export const logout = () => authContextWMD.logOut();
export const wmdAdalApiFetch = (fetch, url, options) =>
  adalFetch(authContextWMD, config.clientId, fetch, url, options);
